// extracted by mini-css-extract-plugin
export var acceptButton = "_19-5";
export var fullContent = "_19-4";
export var link = "_19-6";
export var linkIcon = "_19-7";
export var sideContent = "_19-3";
export var sideImage = "_19-2";
export var sideImageWrapper = "_19-1";
export var splitLayout = "_19-0";